module.exports = __webpack_public_path__ + "img/reset-act.0cb25f97.png";